import { render } from "./2022-10-31-Sort.md?vue&type=template&id=35af3b4c"
const script = {}
script.render = render

export default script